import React from 'react'
import '../styles/Main.styles.css'
/* import ScrollButton from '../elements/ScroolButton' */

export default function Main({children}) {
  return (
    <div className='main-container'>
      {children}
      {/* <ScrollButton /> */}
    </div>
  )
}
